import { render, staticRenderFns } from "./OutOfStockProduct.vue?vue&type=template&id=d0570ce8&scoped=true&"
import script from "./OutOfStockProduct.vue?vue&type=script&lang=js&"
export * from "./OutOfStockProduct.vue?vue&type=script&lang=js&"
import style0 from "./OutOfStockProduct.vue?vue&type=style&index=0&id=d0570ce8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0570ce8",
  null
  
)

export default component.exports